module.exports = __webpack_public_path__ + "img/picture-12.6ab703cc.png";